(function () {
  if (typeof window === 'undefined') return;

  var monthFormatter = new Intl.DateTimeFormat('en-US', { month: 'short' });

  var cloneDate = function (date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  };

  var toInteger = function (value, fallback) {
    var parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? Math.max(0, parsed) : fallback;
  };

  var normalizeRange = function (min, max) {
    var safeMin = toInteger(min, 0);
    var safeMax = toInteger(max, safeMin);
    return safeMin <= safeMax ? [safeMin, safeMax] : [safeMax, safeMin];
  };

  var isBusinessDay = function (date) {
    var day = date.getDay();
    return day !== 0 && day !== 6;
  };

  var addBusinessDays = function (startDate, days) {
    var result = cloneDate(startDate);
    var remaining = toInteger(days, 0);

    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      if (isBusinessDay(result)) remaining -= 1;
    }

    return result;
  };

  var formatDate = function (date) {
    return monthFormatter.format(date) + ' ' + date.getDate();
  };

  var formatDateRange = function (startDate, endDate) {
    if (startDate.toDateString() === endDate.toDateString()) return formatDate(startDate);

    var startMonth = monthFormatter.format(startDate);
    var endMonth = monthFormatter.format(endDate);

    if (
      startDate.getFullYear() === endDate.getFullYear() &&
      startDate.getMonth() === endDate.getMonth()
    ) {
      return startMonth + ' ' + startDate.getDate() + '-' + endDate.getDate();
    }

    return startMonth + ' ' + startDate.getDate() + '-' + endMonth + ' ' + endDate.getDate();
  };

  var getDeliveryEstimate = function (options) {
    var settings = options || {};
    var orderDate = cloneDate(settings.orderDate || new Date());
    var productionDays = normalizeRange(settings.productionMinDays, settings.productionMaxDays);
    var shippingDays = normalizeRange(settings.shippingMinDays, settings.shippingMaxDays);
    var shipStart = addBusinessDays(orderDate, productionDays[0]);
    var shipEnd = addBusinessDays(orderDate, productionDays[1]);
    var deliveryStart = addBusinessDays(shipStart, shippingDays[0]);
    var deliveryEnd = addBusinessDays(shipEnd, shippingDays[1]);

    return {
      orderDate: orderDate,
      shipStart: shipStart,
      shipEnd: shipEnd,
      deliveryStart: deliveryStart,
      deliveryEnd: deliveryEnd,
    };
  };

  var textOrDefault = function (value, fallback) {
    var text = String(value || '').trim();
    return text || fallback;
  };

  var hydrateModule = function (root) {
    if (!root || !root.dataset || root.dataset.estimatedDeliveryReady === 'true') return;
    root.dataset.estimatedDeliveryReady = 'true';

    var estimate = getDeliveryEstimate({
      orderDate: new Date(),
      productionMinDays: root.dataset.productionMinDays,
      productionMaxDays: root.dataset.productionMaxDays,
      shippingMinDays: root.dataset.shippingMinDays,
      shippingMaxDays: root.dataset.shippingMaxDays,
    });
    var deliveryRange = formatDateRange(estimate.deliveryStart, estimate.deliveryEnd);
    var shipRange = formatDateRange(estimate.shipStart, estimate.shipEnd);
    var headlineTemplate = textOrDefault(
      root.dataset.headlineTemplate,
      'Arrives by {date_range} if you order today.'
    );
    var celebrationText = String(root.dataset.celebrationText || '').trim();
    var headline = headlineTemplate.replace('{date_range}', deliveryRange);

    if (celebrationText) headline += ' ' + celebrationText;

    var headlineElement = root.querySelector('[data-estimated-delivery-headline]');
    var placedDateElement = root.querySelector('[data-estimated-delivery-placed-date]');
    var shipDateElement = root.querySelector('[data-estimated-delivery-ship-date]');
    var deliveredDateElement = root.querySelector('[data-estimated-delivery-delivered-date]');

    if (headlineElement) headlineElement.textContent = headline;
    if (placedDateElement) placedDateElement.textContent = textOrDefault(root.dataset.todayLabel, 'Today');
    if (shipDateElement) shipDateElement.textContent = shipRange;
    if (deliveredDateElement) deliveredDateElement.textContent = deliveryRange;
  };

  var init = function (scope) {
    var root = scope || document;
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll('[data-estimated-delivery]').forEach(hydrateModule);
  };

  window.CrystalLabsEstimatedDelivery = {
    addBusinessDays: addBusinessDays,
    formatDateRange: formatDateRange,
    getDeliveryEstimate: getDeliveryEstimate,
    hydrateModule: hydrateModule,
    init: init,
  };

  if (typeof document === 'undefined') return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  if (window.addEventListener) {
    window.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  }
})();
